import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DadosInscricao } from '../shared/DadosInscricao';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { AcompanhamentoService } from '../../acompanhamento/shared/acompanhamento.service';
import { FluxoInscricaoService } from '../shared/fluxoInscricao.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
@Component({
  moduleId: module.id.toString(),
  selector: 'app-dados-pessoais',
  templateUrl: './dados-pessoais.component.html',
  styleUrls: ['./dados-pessoais.component.scss'],
})
export class DadosPessoaisComponent implements OnInit {

  loading = false;
  dadosInscricao: DadosInscricao;
  formData: any;
  podeVoltar = true;
  showAlert = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoInscricaoService: FluxoInscricaoService,
    private blockingSpinnerService: BlockingSpinnerService,
    private pessoaService: PessoaService,
    private acompanhamentoService: AcompanhamentoService,
  ) { }

  ngOnInit() {
    this.dadosInscricao = this.fluxoInscricaoService.getDadosInscricao();
    this.podeVoltar = this.fluxoInscricaoService.passoAtualRetornavel();
  }

  handleFormSubmit(formData: any) {
    this.formData = formData;
    this.blockingSpinnerService.show();
    this.saveDadosCandidato();

  }

  handleVoltar() {
    this.fluxoInscricaoService.voltarPasso();
    const rotaAnterior = this.fluxoInscricaoService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  async saveDadosCandidato() {
    const telefone = this.formData.telefone.replace(/[^\d]+/g, '');
    const nascimento = this.formData.dtNascimento.split('/');

    const pessoa = {
      cpf: this.formData.cpf.replace(/[^\d]+/g, ''),
      nome: this.formData.nome,
      email: this.formData.email,
      dataNascimento: `${nascimento[2]}-${nascimento[1]}-${nascimento[0]}`,
      ddd: telefone.substr(0, 2),
      celular: telefone.substr(2),
      vinculo: this.formData.vinculo,
    };

    if (!this.formData.cadastroExistente) {
      await this.pessoaService.savePessoa({
        pessoa: {
          nome: pessoa.nome,
          email: pessoa.email,
          ddd: pessoa.ddd,
          celular: pessoa.celular,
        },
        cpf: pessoa.cpf,
        dataNascimento: pessoa.dataNascimento,
        isEspecial: 1,
      }).toPromise();
    }

    this.verificaInscricao(pessoa);
  }

  async verificaInscricao(pessoa) {
    try {
      // Busca por incricoes;
      const result = <any>await this.acompanhamentoService.getInscricoes(pessoa.cpf).toPromise();
      if (Object.keys(result).length) {
        // Filtra por inscricoes realizadas;
        const existInscricao = result.inscricoes.filter(inscricao =>
          inscricao.idCurso === this.dadosInscricao.curso.id &&
          inscricao.turno === this.dadosInscricao.turma.turno);

        if (!existInscricao.length) {
          this.nextStep(pessoa);
        } else {
          throw new Error('ExistPerson');
        }
      } else {
        this.nextStep(pessoa);
      }
    } catch {
      this.blockingSpinnerService.close();
      this.showAlert = true;
    }
  }


  hideAlert() {
    this.showAlert = false;
  }

  nextStep(pessoa) {
    this.blockingSpinnerService.close();
    this.fluxoInscricaoService.proximoPasso({ candidato: pessoa });
    const proximaRota = this.fluxoInscricaoService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }


}
